import { FormInstance } from 'antd';
import { Order } from 'constants/interface';
import {
  OrderTypeEnum,
} from 'constants/order';
import React from 'react';
import { Collapse } from 'UI';

import {
  RegularTable,
  RegularOrderItemsFormData,
  GraftingTable,
  GraftingOrderItemsFormData,
} from './components';

import {
  MainContainer,
  OrderItemsCollapse,
} from './style';

export {
  RegularOrderItemsFormData,
  GraftingOrderItemsFormData,
} from './components';

interface OrderItemsProps {
  regularFormHandler: FormInstance<RegularOrderItemsFormData>
  graftingFormHandler: FormInstance<GraftingOrderItemsFormData>
  isLoading: boolean
  orderType: OrderTypeEnum,
  initialOrder?: Order
}

const COLLAPSE_KEY = 'ORDER_ROWS';

const OrderItems = ({
  regularFormHandler,
  graftingFormHandler,
  isLoading: externalLoading,
  orderType,
  initialOrder,
}: OrderItemsProps): JSX.Element => (
  <MainContainer>
    <OrderItemsCollapse
      ghost={false}
      defaultActiveKey={COLLAPSE_KEY}
    >
      <Collapse.Panel
        key={COLLAPSE_KEY}
        header="Itens do pedido"
        forceRender
      >
        {
          orderType === OrderTypeEnum.REGULAR
            ? (
              <RegularTable
                formHandler={regularFormHandler}
                isLoading={externalLoading}
                initialOrder={initialOrder}
              />
            ) : (
              <GraftingTable
                formHandler={graftingFormHandler}
                isLoading={externalLoading}
                initialOrder={initialOrder}
              />
            )
        }
      </Collapse.Panel>
    </OrderItemsCollapse>
  </MainContainer>
);

export default OrderItems;
